// extracted by mini-css-extract-plugin
module.exports = {"content":"DateFilterSection_content__2Bb1E"};